import * as React from 'react';

export interface IAudienceLoaderProps {
	surveyId: number;
	GetAudiences: (surveyId: number) => void;
}

export class AudienceLoader extends React.Component<IAudienceLoaderProps> {
	public componentDidMount() {
		this.props.GetAudiences(this.props.surveyId);
	}

	public render() {
		return <> </>;
	}
}
